import { SizeDimensionKey } from './size-dimension.constants';

export const DEFAULT_LOCAL_SIZE_KEY: SizeDimensionKey = 'eu';

const SIZE_RUN_BY_BILLING_COUNTRY = new Map<string, SizeDimensionKey>([
  ['Japan', 'jp'],
  ['Brazil', 'br'],
  ['United Kingdom', 'uk'],
  ['United States', 'us'],
  ['Mexico', 'mx'],
  ['China', 'cn'],
  ['Taiwan', 'cn'],
]);

/** Local size run for a billing country sfKey; countries without their own run use EU sizes. */
export const resolveLocalSizeKey = (billingCountry?: string): SizeDimensionKey =>
  SIZE_RUN_BY_BILLING_COUNTRY.get(billingCountry ?? '') ?? DEFAULT_LOCAL_SIZE_KEY;

export const ALWAYS_VISIBLE_SIZE_KEY: SizeDimensionKey = 'us';

/** Like resolveLocalSizeKey, but for matrix size selectors: 'us' is always shown there, so it falls back to EU. */
export const resolveMatrixLocalSizeKey = (billingCountry?: string): SizeDimensionKey => {
  const sizeKey = resolveLocalSizeKey(billingCountry);
  return sizeKey === ALWAYS_VISIBLE_SIZE_KEY ? DEFAULT_LOCAL_SIZE_KEY : sizeKey;
};
